const EMAIL_OR_PHONE = 'emailorphone';
const FLOW_PARAM = 'flow';
const REDIRECT_URL_PARAM = 'redirect-url';
const USERNAME = 'email';
const LAST_NAME = 'last-name';
const DOB = 'dob';
const POSTCODE = 'postcode';
const BROWSER_BACK = 'browser-back';

export {
  EMAIL_OR_PHONE,
  FLOW_PARAM,
  REDIRECT_URL_PARAM,
  USERNAME,
  LAST_NAME,
  DOB,
  POSTCODE,
  BROWSER_BACK,
};
